const getUuid = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (ch) => {
    const random = Math.floor(Math.random() * 16);
    const value = ch === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
};

const isNil = (value) => value === null || value === undefined;

module.exports = {
  getUuid,
  isNil,
};
